module.exports = __webpack_public_path__ + "img/thumbnail_HighlandCattle_j_leucistic.181a8019.png";